import { TrackList } from "@/components/tracks/TrackList";
import { DownloadButton } from "@/components/tracks/DownloadButton";
import { useLibrary } from "@/hooks/useLibrary";
import { usePlayer } from "@/hooks/usePlayer";

export function LikedPage() {
  const { likedTracks } = useLibrary();
  const p = usePlayer();
  return (
    <div>
      <div className="row" style={{ justifyContent: "space-between", marginBottom: 14 }}>
        <h1 style={{ margin: 0 }}>Titres likés</h1>
        <div className="row" style={{ gap: 8 }}>
          <button className="btn primary" onClick={() => void p.play(likedTracks, 0)}>▶ Lire tout</button>
          <button className="btn" disabled={!likedTracks.length}
                  title="Lecture aléatoire avec des recommandations ✦ glissées entre tes titres"
                  onClick={() => void p.playSmartShuffle(likedTracks)}>✦ Aléatoire intelligent</button>
          <DownloadButton id="liked" label="Titres likés" tracks={likedTracks} />
        </div>
      </div>
      <TrackList tracks={likedTracks} />
    </div>
  );
}
